import { ref } from 'vue'
import { createGlobalState } from '@vueuse/core'

export const useFormLoader = createGlobalState(() => {
  const showLoader = ref(false)
  const hasResult = ref(false)
  return { showLoader, hasResult }
})
